import { render, staticRenderFns } from "./SocialWallWidget.vue?vue&type=template&id=716f9db2&scoped=true"
import script from "./SocialWallWidget.vue?vue&type=script&lang=js"
export * from "./SocialWallWidget.vue?vue&type=script&lang=js"
import style0 from "./SocialWallWidget.css?vue&type=style&index=0&id=716f9db2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f9db2",
  null
  
)

export default component.exports